import { combineReducers } from 'redux';
import { IOrderPostState, OrderPostReducer, initialOrderPostState } from './OrderPostReducer';
import { IOrderingState, OrderingProductReducer, initialOrderingState } from './OrderingProductReducer';
import { initialOrderedState, IOrderedState, OrderedReducer } from './OrderedReducer';

export interface RootOrderState {
  orderPost: IOrderPostState;   // venstre side (paging + fetch)
  ordering: IOrderingState;     // høyre side (accordion-grupper)
  ordered: IOrderedState;       // bestilte varer
}

export const initialRootOrderState: RootOrderState = {
  orderPost: initialOrderPostState,
  ordering: initialOrderingState,
  ordered: initialOrderedState
};

export const RootOrderReducer = combineReducers<RootOrderState>({
  orderPost: OrderPostReducer,
  ordering: OrderingProductReducer,
  ordered: OrderedReducer
});